import Navbar from 'src/components/NavBar';
import EnterInvoiceContextProvider from 'src/sections/enter_invoice/EnterInvoiceContext';
import EnterInvoiceMain from 'src/sections/enter_invoice/EnterInvoiceMain';
import ShowScansInvoice from 'src/sections/enter_invoice/ShowScansInvoice';
import './EnterInvoices.scss';

function EnterInvoices() {
  return (
    <EnterInvoiceContextProvider>
      <Navbar title="Enter Invoice/Credit Memo" />
      <ShowScansInvoice main={<EnterInvoiceMain />} />
    </EnterInvoiceContextProvider>
  );
}

export default EnterInvoices;
